import React from 'react'
import { useTranslation } from 'react-i18next'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import './ApptHistory.sass'

/**
 * PopperDataTable
 * @param {Object} props
 * @param {Array<string>} props.header - Array of keys to display as columns (e.g. ["poNum", "totalPiece", "totalLbs"])
 * @param {Array<Object>} props.data - Array of objects with keys matching header
 */
const PopperDataTable = ({ header, data, testid }) => {

    const { t } = useTranslation();

    return (
        <TableContainer data-testid='popperDataTable' className='appt-container'>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        {header.map((col, idx) => (
                            <TableCell key={idx} className='cellStyle'>
                                <Typography variant='h5' className='headerColumn' data-testid={`${testid}-headerColumn`}>{t(col)}</Typography>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, rowIdx) => (
                        <TableRow key={rowIdx}>
                            {header.map((col, colIdx) => (
                                <TableCell key={colIdx} className='cellStyle'>
                                    <Typography variant='body1' className='dataColumn' data-testid={`${testid}-dataColumn`}>{row[col]}</Typography>
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default PopperDataTable